import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]

import { getDefaultRewards} from '@/utils/commonFunction';
import { ref } from 'vue'; 
import CashBackCard from './components/cashBackCard.vue';
import CashbackHistoryPopup from './components/cashbackHistoryPopup.vue';
import CashbackNotice from './components/cashbackNotice.vue';
import CashbackWeekDetails from './components/cashbackWeekDetails.vue';
import CustomHeader from '../components/common/customHeader.vue';
import { LossReliefData } from '@/view/lossReliefFunds/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'lossFundReport',
  props: {
    dataSet: {}
  },
  emits: ['getNextPageRewardData','getHistoryList', 'resetHistoryData', 'getClaim'],
  setup(__props: any, { emit: __emit }) {

const histryPopupRef = ref()

const props = __props

const emits = __emit


const getNextPageRewardData = () => {
    emits('getNextPageRewardData')
}

const getHistoryList = () => {
    emits('getHistoryList')
}

const openHistoryPopup = (data: any) => {
    histryPopupRef.value.open(data)
}

const resetHistoryData = () => {
    emits('resetHistoryData')
}

const getClaim = () => {
    emits('getClaim')
}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('activityName.game_benefit'),
      "show-history": true,
      onOpenHistoryPopup: openHistoryPopup
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "fundBannerImage",
                src: _ctx.dataSet.bannerIcon,
                alt: ""
              }, null, 8, _hoisted_2)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(CashbackNotice, {
        content: _ctx.dataSet.activityIntro
      }, null, 8, ["content"]),
      _createElementVNode("div", null, [
        _createVNode(CashBackCard, {
          title: _ctx.$t('common.bets'),
          "create-date": _ctx.dataSet.todayBetDetails?.createTime,
          day: _ctx.dataSet.todayBetDetails?.day,
          "available-value": _ctx.dataSet.todayBetDetails?.availableAmount,
          showClickButton: _ctx.dataSet.todayBetDetails?.availableAmount > 0,
          "given-value": _ctx.dataSet.todayBetDetails?.givenAmount,
          onGetClaim: getClaim,
          dayList: _ctx.dataSet.futureRewards.length <= 0 ? _unref(getDefaultRewards)(_ctx.dataSet.dayCount) : _ctx.dataSet.futureRewards
        }, null, 8, ["title", "create-date", "day", "available-value", "showClickButton", "given-value", "dayList"])
      ]),
      _createVNode(CashbackWeekDetails, {
        "bet-list": _ctx.dataSet.weeklyRewardList,
        title: _ctx.$t('activity.lossTotal'),
        type: "LOSS",
        "cashback-total": _ctx.dataSet.cashbackTotal,
        "istoday-claimed": _ctx.dataSet.todayBetDetails?.availableAmount > 0
      }, null, 8, ["bet-list", "title", "cashback-total", "istoday-claimed"]),
      _createVNode(CashbackHistoryPopup, {
        ref_key: "histryPopupRef",
        ref: histryPopupRef,
        onGetHistoryList: getHistoryList,
        list: _ctx.dataSet.historyList,
        onUpdateHistoryList: getNextPageRewardData,
        showIcon: _ctx.dataSet.total > _ctx.dataSet.pageSize * _ctx.dataSet.pageNum,
        title: _ctx.$t('activity.lossTotal'),
        onResetHistoryData: resetHistoryData
      }, null, 8, ["list", "showIcon", "title"])
    ])
  ], 64))
}
}

})